import { FaHome, FaHistory, FaWallet, FaUser, FaPaperPlane } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";

export default function BottomNav() {
  const location = useLocation();

  const navItems = [
    { to: "/", label: "Accueil", icon: <FaHome /> },
    { to: "/history", label: "Historique", icon: <FaHistory /> },
    { to: "/transfer", label: "Transfert", icon: <FaPaperPlane /> },
    { to: "/wallet", label: "Wallet", icon: <FaWallet /> },
    { to: "/profile", label: "Profil", icon: <FaUser /> },
  ];

  return (
    <div className="fixed bottom-3 left-0 right-0 z-50 px-3">
      <div
        className="mx-auto flex max-w-md items-center justify-between gap-1
                   rounded-2xl border border-black/5 dark:border-white/10
                   bg-white/80 dark:bg-slate-950/70 backdrop-blur-xl shadow-lg px-2 py-2"
      >
        {navItems.map((item) => {
          const active = location.pathname === item.to;
          return (
            <Link
              key={item.to}
              to={item.to}
              className={`flex flex-1 flex-col items-center justify-center gap-1 rounded-xl px-2 py-2 transition
                ${active ? "bg-slate-900 text-white dark:bg-white dark:text-slate-900" : "text-slate-500 dark:text-slate-300 hover:bg-black/5 dark:hover:bg-white/10"}
              `}
            >
              <div className="text-lg">{item.icon}</div>
              <span className="text-[11px] font-medium">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
